import {UPDATE_OWNER_DETAILS, CLEAR_NEW_LIABILITY_POLICY} from '../actions/types';

export const ownerDetailsPolicyReducer = (state = {} , action) => {
    switch(action.type) {
        case UPDATE_OWNER_DETAILS:
            return {...state, ...action.payload} || {};
        case CLEAR_NEW_LIABILITY_POLICY: 
            return {};
            
        default:
            return state;
    }
}